interface CheckIconProps {
  width?: number; 
  height?: number; 
  color?: string; 
  strokeWidth?: number; 
}

export const CheckIcon: React.FC<CheckIconProps> = ({
  width = 50,
  height = 50,
  color = 'black',
  strokeWidth = 2, 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill={color} 
    >
      <path
        d="M20 35 L10 25 L12.5 22.5 L20 30 L37.5 12.5 L40 15 L20 35 Z"
        fill={color} 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
    </svg>
  );
};
